import { generateUtilityClasses, styled } from '@mui/material';
import { Pagination } from 'react-instantsearch';

export const COMPONENT_NAME = 'PrcSearchPaginationStyled';

const baseChartClasses = {
  ...generateUtilityClasses(COMPONENT_NAME, ['selectedItem']),
};

const PaginationStyled = styled(Pagination)<{ hidden?: boolean }>(({ hidden, theme }) => ({
  display: hidden ? 'none' : 'flex',
  justifyContent: 'center',
  paddingTop: 12,
  ul: {
    display: 'flex',
    listStyleType: 'none',
    gap: 8,
    li: {
      display: 'flex',
      justifyContent: 'center',
      minWidth: 32,
      padding: 4,
      borderRadius: 4,
      a: {
        ...theme.typography.button,
        color: theme.palette.primary.main,
        textDecoration: 'none',
      },
    },
    [` .${baseChartClasses.selectedItem}`]: {
      backgroundColor: theme.palette.grey[300],
    },
  },
}));

interface SearchPaginationProps {
  hidden?: boolean;
}

export const SearchPagination = ({ hidden }: SearchPaginationProps) => {
  return (
    <PaginationStyled
      hidden={hidden}
      classNames={{
        selectedItem: baseChartClasses.selectedItem,
      }}
    />
  );
};
